import styled from "styled-components"
import { Link } from "react-router-dom"
import { IconButton } from "@material-ui/core"

export const Holder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  background-color: white;
`
export const Viewer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  overflow-x: auto;
`
export const ViewerPivot = styled.div`
  width: fit-content;
  height: 100%;
  display: flex;
`
export const AboutLink = styled(Link)`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
  z-index: 999;
`
export const BackButton = styled(IconButton)`
  width: 3em;
  height: 3em;
`
export const BackIcon = styled.img`
  width: 100%;
`
